/**
 * A branded string type representing a calendar date in YYYY-MM-DD format.
 *
 * Use `toISODateString` to construct a validated value. Raw string literals
 * are intentionally rejected by the type system to prevent accidentally
 * passing display-formatted strings (e.g. "26/06/25") or full ISO datetimes
 * (e.g. "2026-06-25T10:00:00Z") into fields that expect a plain date.
 */
export type ISODateString = string & { readonly __brand: unique symbol };

/**
 * Validates and casts a string to `ISODateString`.
 *
 * @throws if the value does not match YYYY-MM-DD.
 *
 * @example
 * toISODateString(dayjs(date).format("YYYY-MM-DD"))
 */
export function toISODateString(value: string): ISODateString {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    throw new Error(
      `Invalid ISO date string: expected YYYY-MM-DD, got "${value}"`,
    );
  }
  return value as ISODateString;
}
